import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div>
        <NavMenu />
        <Container tag="main" className="container-fluid min-vh-100">
          {this.props.children}
            </Container>
        <footer className="text-center"><span>Pocahontas, logiciel de gestions des profils / appels d'offres (c) Softeam 2023</span></footer>
      </div>
    );
  }
}
